<template>
	<div
		class="assignment-table-container"
		:style="`color:${$appColors.primary};border: 1px solid ${$appColors.gray};`"
	>
		<div class="assignment-grid">
			<span
				v-for="(col, indexCol) in columns"
				:key="indexCol"
				class="column-title"
			>
				{{col.name}}
			</span>
		</div>
		<ul>
			<li
				v-for="(row, indexRow) in rows" :key="indexRow"
				 class="assignment-grid row column-title"
				 :style="`border-top:1px solid ${$appColors.gray};color:${$appColors.info}`"
			>
				<div>{{row.name}}</div>
				<div style="padding-left:20px">{{row.points}}</div>
				<div v-if="columns.length === 3">
					<app-button
						class="assignment-btn"
						:style="`background-color: ${$appColors.primary};`"
						text="Asignar"
						@click="iWantThisPresent(row)"
					/>
				</div>
			</li>
		</ul>
	</div>
</template>
<script>
import appButton from '@/components/shared/app-button';

async function iWantThisPresent(present) {
	const obj = {
		presentId: present.id,
		employeeId: this.$route.params.employeeId,
	};
	await this.$store.dispatch('presentsConfiguration/redeemPresent', obj);
	this.showNotification('Premio canjeado con éxito', 'success');
}

export default {
	name: 'presents-table',
	components: {
		appButton,
	},
	methods: {
		iWantThisPresent,
	},
	props: {
		columns: {
			required: true,
			type: Array,
		},
		rows: {
			required: true,
			type: Array,
		},
	},
};
</script>
<style lang="scss" scoped>
.assignment-table-container {
	background-color: white;
	border-radius: 4px;

	.assignment-grid {
		align-items: center;
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
	}

	.column-title {
		padding: 14px 20px;
	}

	ul {
		padding: 0;

		.row {

			.assignment-btn {
				border-radius: 5px;
				color: white;
				font-family: font(bold);
				margin: 0 5px;
				padding: 5px 20px;
			}
		}
	}

}
</style>


// WEBPACK FOOTER //
// src/components/configuration/employees/presentsTable.vue